import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from '../../layout/Card';
import ModuleHome from '../../layout/ModuleHome';
import { breadcrumbsPropTypes } from '../../common/resource/proptypes/CommonPropTypes';

const SupervisionControlHome = ({
  cards, breadcrumbs
}) => (
  <ModuleHome
    title="Gestión de Supervisión y Control"
    text="Éste es el módulo de Gestión de Supervisión y Control."
    cards={cards}
    breadcrumbs={breadcrumbs}
  />
)

const mapStateToProps = ({ SupervisionControlUnit }) => ({
  cards: SupervisionControlUnit.UnitHome.get('cards'),
  breadcrumbs: SupervisionControlUnit.UnitHome.get('breadcrumbs'),
});

SupervisionControlHome.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)).isRequired,
};

export default connect(mapStateToProps)(SupervisionControlHome);
